<template lang="pug">
	.actions-create-new-website-css(v-if="showed")
		.card
			.card-header
				span Create New Domain
			.card-body.collapse.show
				.form-horizontal
					.form-group
						.input-state(v-if="state === 'input'")
							label.col-form-label Website Domain
								.controls
									input.form-control(size="100" type="text" v-model="domain")
						.fetching-state(v-else-if="state === 'fetching'")
							.icon.fa.fa-spinner.fa-spin
						.error-state(v-else-if="state === 'error'")
							span {{error}}
					.form-actions
						button.btn.btn-primary(type="submit" ref="button" disabled v-on:click="create()") Create
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';

	export default {
		name: "ActionsCreateNewWebsiteCss",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false,
			events: {
				'Create Css Domain Result': function (error, result) {
					if (error) {
						this.state = 'error';
						this.error = error;
						return;
					}

					Broadcast.call('Add Website Css', [result]);

					this.hide();
				}
			}
		},
		watch: {
			domain(val) {

				if (this.$refs.button) this.$refs.button.disabled = !(val.length && this.state === 'input');

			},
		},
		data() {

			return {
				domain: '',
				error: '',
				state: 'input',
				buttonDisabled: false
			}
		},
		methods: {
			collectData() {

				this.state = 'input';
				this.domain = '';
				this.error = '';


			},
			create() {
				Server.sendToSocket({
					DoesWebsiteCSSExist: {
						domain: this.domain
					}
				});

				this.state = 'fetching';

				this.$refs.button.disabled = true;
			}
		}
	}
</script>


<style lang="sass">

	.actions-create-new-website-css
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 220px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.fetching-state, .error-state
				display: flex
				flex-direction: row
				align-items: center
				justify-content: center
				height: 75px

			.error-state
				font-size: 50px

			.error-state
				font-size: 20px

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

			.btn:disabled
				cursor: not-allowed


</style>

